import { render } from "./FaqItem.vue?vue&type=template&id=26dbb710&scoped=true&ts=true"
import script from "./FaqItem.ts?vue&type=script&lang=ts&external"
export * from "./FaqItem.ts?vue&type=script&lang=ts&external"

import "./FaqItem.scss?vue&type=style&index=0&id=26dbb710&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dbb710"]])

export default __exports__